export enum TERM_LENGTH_FORMAT {
  abv = 'abv',
  hyphen = 'hyphen',
  full_term = 'full_term',
}

const yearFormat = ({ format, unit }: { format: TERM_LENGTH_FORMAT; unit: number }) => {
  const isPlural = unit > 1;

  switch (format) {
    case TERM_LENGTH_FORMAT.abv:
      return 'yr';
    case TERM_LENGTH_FORMAT.hyphen:
      return '-year';
    case TERM_LENGTH_FORMAT.full_term:
    default:
      return isPlural ? ' years' : ' year';
  }
};

const monthFormat = ({ format, unit }: { format: TERM_LENGTH_FORMAT; unit: number }) => {
  const isPlural = unit > 1;

  switch (format) {
    case TERM_LENGTH_FORMAT.abv:
      return 'mo';
    case TERM_LENGTH_FORMAT.hyphen:
      return '-month';
    case TERM_LENGTH_FORMAT.full_term:
    default:
      return isPlural ? ' months' : ' month';
  }
};

export const formatLabel = ({
  cdDepositTerm,
  format = TERM_LENGTH_FORMAT.full_term,
  displayName,
}: {
  cdDepositTerm?: number;
  format?: TERM_LENGTH_FORMAT;
  displayName?: string;
}): string => {
  if (!cdDepositTerm) {
    return '';
  }

  let suffix = '';

  if (displayName?.match(/bump|\braise\b/i)) {
    suffix = ' bump-up';
  } else if (displayName?.match(/no.*?penalty/i)) {
    suffix = ' no-penalty';
  } else if (displayName?.match(/jumbo/i)) {
    suffix = ' jumbo';
  }

  const months = Math.round(cdDepositTerm / 30);
  const threshold = 0.1;
  if (
    Math.abs(months % 12) < threshold ||
    (months > 12 && Math.abs((months % 12) - 6) < threshold)
  ) {
    const years = months / 12;
    return years + yearFormat({ format, unit: years }) + suffix;
  }

  return months + monthFormat({ format, unit: months }) + suffix;
};
